<div class="watermark-overlay" 
  *ngIf="isDisplayOverlay" 
  [ngStyle]="{'z-index': watermarkSetting.zIndex}">
  <canvas #watermarkOverlayCanvas></canvas>
</div>